import React, { Component } from "react";

import "./notFound.scss";

class App extends Component {
  render() {
    return (
      <main className="not-found-page">
        <div className="not-found-content">
          <div className="not-found-icon" aria-hidden="true">
            <span className="not-found-icon-eye" />
            <span className="not-found-icon-mouth" />
          </div>
          <h1>No se puede acceder a este sitio</h1>
          <p>La pagina que estas buscando no se encuentra disponible.</p>
          <span className="not-found-code">
            ERR_PAGE_NOT_AVAILABLE
          </span>
        </div>
      </main>
    );
  }
}
export default App;
